import { render, staticRenderFns } from "./EfsStdMarginForm.vue?vue&type=template&id=63308321&"
import script from "./EfsStdMarginForm.vue?vue&type=script&lang=js&"
export * from "./EfsStdMarginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports